module.exports = __webpack_public_path__ + "static/nasa4-frame-21055283c969be15c04c379841a6c161.gif";